import controller from "./passwordLogin.controller";
import template from "./passwordLogin.template.html";

const component = {
  restrict: "E",
  template,
  controller,
  bindings: {},
};

export default component;
